var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.84,15.75h2.43a3.78,3.78,0,0,0,3.53-4V6a3.78,3.78,0,0,0-3.53-4H10.84A3.79,3.79,0,0,0,7.3,6v5.79A3.79,3.79,0,0,0,10.84,15.75Zm-1.8-4V6a1.93,1.93,0,0,1,1.8-2h2.43a1.92,1.92,0,0,1,1.79,2v5.79a1.92,1.92,0,0,1-1.79,2H10.84A1.93,1.93,0,0,1,9,11.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.69,9.44v3.21a4,4,0,0,1-4,4H10.28a4,4,0,0,1-4-4V9.44h-2v3.21a6,6,0,0,0,5.93,5.94h.62a.12.12,0,0,1,.12.12v1.21a.12.12,0,0,1-.12.12H7.75v2h8.5V20H13.1a.12.12,0,0,1-.12-.12V18.71a.12.12,0,0,1,.12-.12h.62a6,6,0,0,0,5.93-5.94V9.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13,8.17a1.21,1.21,0,1,0,0-2.41h0a1.21,1.21,0,1,0,0,2.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13,11.29a1.21,1.21,0,0,0,0-2.42h0a1.21,1.21,0,1,0,0,2.42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic-on.91b92497c39183fe95912b454b051fbf.svg";
export { ForwardRef as ReactComponent };